import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setClassNames } from 'ddc-classnames-js';
import { useRequestData, useLabels } from 'wsm-common-data';
import { FetchReviewsContext } from '../providers/FetchReviewsProvider';
import { updateModelFilters } from '../actions/reviewsFilters';

const ModelFilters = () => {
	// hooks
	const { deviceType } = useRequestData();
	const labels = useLabels();
	/**
	 * @type {ModelsState}
	 */
	const models = useSelector((state) => state.reviewsFilters.models);
	/**
	 * @type {FetchReviewsContextValue}
	 */
	const { isLoading, fetchReviews } = useContext(FetchReviewsContext);
	// variables
	const isDesktop = deviceType === 'DESKTOP';

	// sort models alphabetically
	const sortedModels = Object.entries(models).sort(([modelA], [modelB]) => {
		return modelA.toLowerCase().localeCompare(modelB.toLowerCase());
	});
	const middleIndex = Math.ceil(sortedModels.length / 2);
	// first column of models
	const firstHalf = sortedModels.slice(0, middleIndex);
	// second column of models
	const secondHalf = sortedModels.slice(middleIndex);
	// classes
	const fieldsetClasses = [
		isDesktop ? '' : 'row-gap',
		'model-filters',
		'filters',
		'flex-row',
		'justify-content-around'
	];
	const legendClasses = ['model-filters__legend', 'font-weight-bold'];
	return (
		<fieldset className={setClassNames(fieldsetClasses)}>
			<legend className={setClassNames(legendClasses)}>
				{labels.get('VW_REVIEWS_FILTER_MODELS')}
			</legend>
			<div className="model-filters__container--left">
				{firstHalf.map(([model, value]) => (
					<ModelFilter
						key={model.replace(/\s/g, '-')}
						model={model}
						checked={value}
						value={model}
						disabled={isLoading}
						fetchReviews={fetchReviews}
					/>
				))}
			</div>
			<div className="model-filters__container--right">
				{secondHalf.map(([model, value]) => (
					<ModelFilter
						key={model}
						model={model}
						checked={value}
						value={model}
						disabled={isLoading}
						fetchReviews={fetchReviews}
					/>
				))}
			</div>
		</fieldset>
	);
};

function ModelFilter({ model, fetchReviews, ...delegatedProps }) {
	// hooks
	const dispatch = useDispatch();
	const id = `model-filter__checkbox--${model
		.toLowerCase()
		.replace(/\s/g, '-')}`;
	const labelClasses = ['model-filters__label'];
	const handleModelFilterChange = (event) => {
		const { checked, value: modelName } = event.target;
		dispatch(updateModelFilters(modelName, checked));
		const queries = {
			models: {
				[modelName]: checked
			}
		};
		fetchReviews(1, queries);
	};
	return (
		<div className="model-filters__filter filter">
			<label
				key={`model-filter__${model.toLowerCase().replace(/\s/g, '-')}`}
				htmlFor={id}
				className={setClassNames(labelClasses)}
			>
				<input
					{...delegatedProps}
					name={model}
					id={id}
					type="checkbox"
					onChange={handleModelFilterChange}
				/>{' '}
				{model}
			</label>
		</div>
	);
}

ModelFilter.propTypes = {
	model: PropTypes.string.isRequired,
	fetchReviews: PropTypes.func.isRequired
};

export default ModelFilters;
